module.exports = __webpack_public_path__ + "static/media/logoImageOnly.f045d089.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logoImageOnly.svg
// module id = 963
// module chunks = 0